import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

type UseFlightSegments = [any, boolean, string?];

export const useFlightSegments = (quoteId?: number): UseFlightSegments => {
  const [flightSegments, setFlightSegments] = useState<TrpcOutputs['getFlightSegmentsByQuoteId']>([]);
  const {
    data: initialData,
    isLoading,
    error,
  } = trpc.getFlightSegmentsByQuoteId.useQuery({ quoteId }, { refetchOnWindowFocus: false, enabled: !!quoteId });

  useEffect(() => {
    if (initialData) {
      const formattedData = initialData?.map((data) => ({
        ...data,
        aircraft_name: data?.aircraft?.name,
      }));
      setFlightSegments(formattedData);
    }
  }, [initialData]);

  trpc.onFlightSegmentCreated.useSubscription(
    { quoteId },
    {
      onData: (data) => setFlightSegments((prev) => [...prev, data.flightSegment]),
      onError: (error) => console.log('onFlightSegmentCreated.error: ', error),
    },
  );

  trpc.onFlightSegmentUpdated.useSubscription(
    { quoteId },
    {
      onData: (data) =>
        setFlightSegments((prev) =>
          prev.map((flightSegment) => {
            if (flightSegment.id === data.flightSegment?.id) return data.flightSegment;
            return flightSegment;
          }),
        ),
      onError: (error) => console.log('onFlightSegmentUpdated.error: ', error),
    },
  );

  trpc.onFlightSegmentsUpdated.useSubscription(
    { quoteId },
    {
      onData: ({ flightSegments }) => setFlightSegments(flightSegments),
      onError: (error) => console.log('onFlightSegmentsUpdated.error: ', error),
    },
  );

  trpc.onFlightSegmentDeleted.useSubscription(
    { quoteId },
    {
      onData: (deletedId) =>
        setFlightSegments((prev) => prev.filter((flightSegment) => flightSegment.id !== deletedId)),
      onError: (error) => console.log('onFlightSegmentDeleted.error: ', error),
    },
  );

  return [flightSegments, isLoading, error?.message] as const;
};
